import * as qs from 'query-string'

const onboardingRoutesPrefix = {
  rso: '', // rapid shipper onboarding
  rfp: '/rfp-manager',
}

export type TOnboardingVariants = keyof typeof onboardingRoutesPrefix

export const stepRoutesByName = {
  index: '/onboarding',
  checkEmail: '/onboarding/check-email',
  existingShipper: '/onboarding/existing-shipper-email',
  newPasswordShipper: '/new-user/password/:token',
  intent: '/onboarding/signup-intent',
  personalInfo: '/onboarding/personal-information',
  shipperInformation: '/onboarding/shipper-information',
}

// Append optional `token` param to end of route
export const onboardingStepRoutes = Object.values(stepRoutesByName)

type TRouteName = keyof typeof stepRoutesByName

interface IParams {
  token?: string
}

/**
 * Helper method to get route along with any optional params
 */
export const getRoute = (
  routeName: TRouteName,
  params: IParams = {},
  variant: TOnboardingVariants = 'rso'
): string => {
  let route = stepRoutesByName[routeName]
  if (Object.keys({ ...params }).length) {
    route += `?${qs.stringify({ ...params })}`
  }
  return `${onboardingRoutesPrefix[variant]}${route}`
}
